
/**
 * 인증 제공자
 */
export type UserResponseProvider = typeof UserResponseProvider[keyof typeof UserResponseProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserResponseProvider = {
  LOCAL: 'LOCAL',
  GOOGLE: 'GOOGLE',
  GITHUB: 'GITHUB',
  FACEBOOK: 'FACEBOOK',
} as const;
